export default __webpack_public_path__ + "static/media/henry8.30b82808.png";